<template>
  <button
    :class="[buttonClass, small ? 'w-auto px-2 py-1 text-xs rounded-full' : 'w-full px-6 py-4 text-base rounded-full', (disabled || loading) ? 'pointer-events-none touch-none opacity-60' : '', 'flex items-center justify-center gap-2 font-semibold transition focus:outline-none']"
    :disabled="disabled || loading"
    @click="handleClick"
  >
    <span v-if="isLoading">
      <svg aria-hidden="true" class="inline w-8 h-8 text-white animate-spin dark:text-gray-600 fill-black" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#fff"/>
    </svg>
    <span class="sr-only">Loading...</span>
    </span>
    <span v-else>
      <span class="flex items-center gap-2">
        <slot />
      </span>
    </span>
  </button>
</template>

<script>
export default {
  name: "CuButton",
  props: {
    primary: { type: Boolean, default: false },
    secondary: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  },
  data() {
    return {
      internalLoading: false
    };
  },
  computed: {
    buttonClass() {
      if (this.primary) {
        return "rounded-full bg-primary hover:bg-primary/90 text-white shadow disabled:opacity-60 disabled:cursor-not-allowed";
      }
      if (this.secondary) {
        return "rounded-full border-2 border-gray-200 text-gray-400 bg-white hover:bg-gray-50 shadow-sm disabled:opacity-60 disabled:cursor-not-allowed";
      }
      if (this.dark) {
        return "rounded-full bg-black text-white shadow disabled:opacity-60 disabled:cursor-not-allowed";
      }
      return "rounded-full bg-gray-200 text-gray-700";
    },
    isLoading() {
      return this.loading || this.internalLoading;
    }
  },
  methods: {
    handleClick(event) {
      if (!this.disabled && !this.isLoading) {
        this.internalLoading = true;
        setTimeout(() => {
          this.internalLoading = false;
          this.$emit('click', event);
        }, 250);
      }
    }
  }
};
</script>
